// Pro pricing, shared by the in-app plans modal and the public pricing page.
// Pro is sold in blocks of 1,000 minutes; USD per month for each block.
export const PRICE_PER_BLOCK = { monthly: 20, yearly: 16 };
export const MINUTE_OPTIONS = [1000, 2000];

export const monthlyPrice = (minutes, period) => (PRICE_PER_BLOCK[period] * minutes) / 1000;
